/***********
 * create by hu at 20230427
 * 延迟加载路由配置
 *
 * 待处理问题：
 * 1，不同类型用户登录变更页面布局
 * 2，不同登录方式变更布局
 *
 * 参数注释：
 * {requiresAuth} 认证路由
 **********/
const routes = [
    { path: '/login/', name: 'login', component: () => import('../views/login.vue') },
    { path: '/sso/', name: 'sso', component: () => import('../views/sso.vue') },
    { path: '/sso/:pageName/', name: 'ssoEdi', component: () => import('../views/sso.vue') },
    {
        path: '/', name: 'default', component: () => import('../views/layout/base.vue'),
        children: [
            {
                path: '/', name: 'home', component: () => import('../views/home.vue'), meta: { requiresAuth: true },
                redirect: { name: 'sso' },
            },
            {
                path: '/send-order', name: 'sendOrder', component: () => import('../views/send-order/index'), meta: { requiresAuth: true },
            },
            {
                path: '/material-data', name: 'materialData', component: () => import('../views/material-data/index'), meta: { requiresAuth: true },
            },
            {
                path: '/list-price', name: 'listPrice', component: () => import('../views/list-price/index'), meta: { requiresAuth: true },
            },
            {
                path: '/material-comp', name: 'materialComp', component: () => import('../views/material-comp/index'), meta: { requiresAuth: true },
            },
            {
                path: '/quotation', name: 'quotation', component: () => import('../views/quotation/index'), meta: { requiresAuth: true },
            },
            {
                path: '/quotation-oms/:id', name: 'quotationOms', component: () => import('../views/quotation/oms'), meta: { requiresAuth: true },
            },
            {
                path: '/purchase-order', name: 'purchaseOrder', component: () => import('../views/purchase-order/index'), meta: { requiresAuth: true },
            },
            {
                path: '/send-purchase-order/:id', name: 'sendPurchaseOrder', component: () => import('../views/send-purchase-order/index'), meta: { requiresAuth: true },
            },
            {
                path: '/order-confirmation', name: 'orderConfirmation', component: () => import('../views/order-confirmation/index'), meta: { requiresAuth: true },
            },
            {
                path: '/proforma-invoice', name: 'proformaInvoice', component: () => import('../views/proforma-invoice/index'), meta: { requiresAuth: true },
            },
            {
                path: '/shipping-notice', name: 'shippingNotice', component: () => import('../views/shipping-notice/index'), meta: { requiresAuth: true },
            },
            {
                path: '/delivery-details', name: 'deliveryDetails', component: () => import('../views/delivery-details/index'), meta: { requiresAuth: true },
            },
            {
                path: '/purchase-receipt', name: 'purchaseReceipt', component: () => import('../views/purchase-receipt/index'), meta: { requiresAuth: true },
            },
            {
                path: '/inventory-information', name: 'inventoryInformation', component: () => import('../views/inventory-information/index'), meta: { requiresAuth: true },
            },
            {
                path: '/downstream-sales', name: 'downstreamSales', component: () => import('../views/downstream-sales/index'), meta: { requiresAuth: true },
            },


            {
                path: '/sevice-state', name: 'sevice-state', component: () => import('../views/sevice-state.vue'), meta: { requiresAuth: true },
            },


            {
                path: '/invetory', name: 'invetory', component: () => import('../views/invetory.vue'), meta: { requiresAuth: true },
            },
            {
                path: '/invoice', name: 'invoice', component: () => import('../views/invoice.vue'), meta: { requiresAuth: true },
            },
            {
                path: '/logs', name: 'logs', component: () => import('../views/logs.vue'), meta: { requiresAuth: true },
            },
            {
                path: '/sales', name: 'sales', component: () => import('../views/sales.vue'), meta: { requiresAuth: true },
            },
            {
                path: '/system', name: 'system', component: () => import('../views/system.vue'), meta: { requiresAuth: true },
            },
            {
                path: '/erp-fields', name: 'erpfields', component: () => import('../views/erp-fields.vue'), meta: { requiresAuth: true }
            },
            {
                path: '/regcustomer', name: 'regcustomer', component: () => import('../views/regcustomer.vue'), meta: { requiresAuth: true }
            },
        ]
    },
]

export default routes
